export default __webpack_public_path__ + "static/media/telemetry.fa7f1b92.png";